// extracted by mini-css-extract-plugin
export default {"loading_icon":"LoadingSpinner_loading_icon__ZUBBx","loading_icon_wrapper":"LoadingSpinner_loading_icon_wrapper__3bNYd","slide-down":"LoadingSpinner_slide-down__XV74U"};